import { createSlice, createAsyncThunk, compose } from '@reduxjs/toolkit';
import Message from '@web-common/components/UI/Message/SiriusMessage';
import { api, apis, util, } from 'api';
import { config } from 'env_def';
import SiriusModal from '@web-common/components/UI/Modal/SiriusModal';
import { sendLogout, setLoginBlock } from '@web-common/utils/utils';
import { getIn18Text } from 'api';
import { cloneDeep } from 'lodash';
const productAuthApi = api.requireLogicalApi(apis.productAuthApiImpl);
const contactApi = api.requireLogicalApi(apis.contactApiImpl);
const loginApi = api.requireLogicalApi(apis.loginApiImpl);
const eventApi = api.getEventApi();
const systemApi = api.getSystemApi();
const registerApi = api.requireLogicalApi(apis.registerApiImpl);
const accountApi = api.requireLogicalApi(apis.accountApiImpl);
const storeApi = api.getDataStoreApi();
const httpImpl = api.getDataTransApi();
const InitialState = {
    loginLoading: false,
    loginInfo: {
        loginId: '',
        loginAccount: '',
        nickName: '',
        isCorpMailMode: systemApi.getIsCorpMailMode(),
    },
    passPrepareFormVisible: false,
    accountList: {
        aliasList: [],
        localList: [],
        mobileList: [],
    },
    switchingAccount: '',
    mobileBindAccountListInfo: {
        accountList: [],
        visibleAccount: false,
        visibleList: false,
        from: 'login',
    },
    settingLoginInfo: {
        loginVisible: false,
        passResetVisible: false,
    },
    loginModalData: {
        visible: false,
    },
    visibleSwitchModal: false,
    visibleSuccessModal: false,
    visibleMobileBindModal: false,
    registerResultDialogVisible: false,
    goLoginNoConfirm: false,
    registerSuccess: false,
    serviceList: [],
    registerInfo: {
        visible: false,
        isValidate: false,
        corpName: '',
        domainPrefix: '',
        adminName: '',
        adminAccount: '',
        mobile: '',
        code: '',
        sid: '',
        selfDomain: '',
        registerTime: 0,
    },
    mailBindModalInfo: {
        visible: false,
        account: '',
        pwd: '',
    },
    sharedAccount: {
        unread: false,
        email: '',
        nickName: '',
        alias: [],
        isSharedAccountLogin: false,
        isSharedAccount: false,
        sharedAccounts: [],
    },
};
const LoginSlice = createSlice({
    name: 'loginReducer',
    initialState: InitialState,
    reducers: {
        setSettingLoginInfo: (state, actions) => {
            state.settingLoginInfo = Object.assign(state.settingLoginInfo, actions.payload);
        },
        setMobileBindAccountListInfo: (state, actions) => {
            state.mobileBindAccountListInfo = Object.assign(state.mobileBindAccountListInfo, actions.payload);
        },
        setVisibleSwitchModal: (state, actions) => {
            state.visibleSwitchModal = actions.payload;
        },
        setRegisterResultDialogVisible: (state, actions) => {
            state.registerResultDialogVisible = actions.payload;
        },
        setGoLoginNoConfirm: (state, actions) => {
            state.goLoginNoConfirm = actions.payload;
        },
        setRegisterSuccess: (state, actions) => {
            state.registerSuccess = actions.payload;
        },
        setServiceList: (state, actions) => {
            state.serviceList = actions.payload;
        },
        setVisibleSuccessModal: (state, actions) => {
            state.visibleSuccessModal = actions.payload;
        },
        setVisibleMobileBindModal: (state, actions) => {
            state.visibleMobileBindModal = actions.payload;
        },
        setRegisterInfo: (state, actions) => {
            state.registerInfo = Object.assign(state.registerInfo, actions.payload);
        },
        setMailBindModalInfo: (state, actions) => {
            state.mailBindModalInfo = Object.assign(state.mailBindModalInfo, actions.payload);
        },
        setAccountList: (state, actions) => {
            state.accountList = actions.payload;
        },
        doSetLoginInfo: (state, action) => {
            const { loginAccount, loginId, nickName } = action.payload;
            state.loginInfo = {
                loginAccount,
                nickName,
                loginId: compose(btoa, btoa, btoa)(loginId),
            };
        },
        doSetRefreshLoading: (state, action) => {
            state.loginLoading = action.payload;
        },
        doTogglePassPrepareForm: (state, action) => {
            state.passPrepareFormVisible = action.payload;
        },
        setSwitchingAccount: (state, action) => {
            state.switchingAccount = action.payload;
        },
        setSharedAccount: (state, action) => {
            state.sharedAccount = action.payload;
        },
        setLoginModalData: (state, action) => {
            state.loginModalData = Object.assign(Object.assign({}, state.loginModalData), (action.payload || {}));
        },
        setOrgInfo: (state, action) => {
            state.orgInfo = action.payload;
        },
    },
});
export const { actions } = LoginSlice;
export const doListAccountsAsync = createAsyncThunk('loginReducer/listAccount', async (isCache, { dispatch }) => {
    try {
        const data = await accountApi.doGetAccountList(isCache);
        dispatch(actions.setAccountList(data));
    }
    catch (error) {
    }
});
export const doSharedAccountAsync = createAsyncThunk('loginReducer/sharedAccount', async (refresh, { dispatch }) => {
    try {
        let data = await accountApi.getSharedAccountsInfoAsync(refresh);
        if (data) {
            const sharedAccounts = (data === null || data === void 0 ? void 0 : data.sharedAccounts) || [];
            let contactInfos = [];
            try {
                contactInfos = await contactApi.doGetContactByItem({ type: 'EMAIL', value: sharedAccounts.map(item => item.email) });
            }
            catch (error) {
                console.log('error', error);
            }
            const newAccounts = sharedAccounts.map(oldItem => {
                var _a, _b;
                const item = cloneDeep(oldItem);
                const findOne = (contactInfos || []).find(contact => { var _a; return ((_a = contact === null || contact === void 0 ? void 0 : contact.contact) === null || _a === void 0 ? void 0 : _a.accountName) === item.email; });
                if ((_a = findOne === null || findOne === void 0 ? void 0 : findOne.contact) === null || _a === void 0 ? void 0 : _a.avatar) {
                    item.avatar = (_b = findOne === null || findOne === void 0 ? void 0 : findOne.contact) === null || _b === void 0 ? void 0 : _b.avatar;
                }
                return item;
            });
            data = Object.assign(Object.assign({}, data), { sharedAccounts: newAccounts });
            dispatch(actions.setSharedAccount(data));
        }
    }
    catch (error) {
    }
});
const switchLocalAccount = async (id) => {
    let pass;
    if (window && window.electronLib) {
        pass = await electronSwitchAccount(id);
    }
    else {
        pass = await webSwitchAccount(id);
    }
    return pass;
};
const setAccountExpired = async (id) => {
    await accountApi.doUpdateAccountList([
        {
            id,
            expired: true,
        },
    ]);
};
const reloadToMainPage = () => {
    systemApi.reloadToMainPage();
};
const handleSwitchAccountSuccessed = async () => {
    if (window && window.electronLib) {
        systemApi.switchLoading(true);
        try {
            await window.electronLib.masterBridgeManage.flush('');
            await window.electronLib.windowManage.closeAllWindowExceptMain(true);
            setTimeout(async () => {
                loginApi.createBKStableWindow();
                reloadToMainPage();
            }, 200);
        }
        catch (ex) {
            console.error(`closeAllWindowExceptMain error`, ex);
        }
    }
    else {
        Message.success(getIn18Text('QIEHUANZHANGHAOCHENGG！'));
        systemApi.switchLoading(true);
        setTimeout(async () => {
            reloadToMainPage();
        }, 200);
    }
};
const electronSwitchAccount = (id) => {
    return new Promise(async (resolve, reject) => {
        const [account, accountInfo] = await accountApi.doGetAllAccountList();
        const swictAccount = (account || []).filter(item => item.id === id);
        const browserUUId = storeApi.getUUID();
        const sessionName = `memory-${new Date().getTime().toString()}`;
        const { winId } = await systemApi.createWindowWithInitData({
            type: 'bkLogin',
            additionalParams: {
                bkLoginInit: true,
                sessionName,
            },
            manualShow: true,
            sessionName: sessionName,
        }, {
            eventName: 'initBkLoginPage',
            eventData: {
                account: swictAccount,
                accountInfo,
                browserUUId,
                accountId: id,
            },
        });
        const timer = setTimeout(() => {
            if (config('stage') === 'prod') {
                systemApi.closeSubWindow(winId, false, true);
            }
            else {
                SiriusModal.error({
                    title: getIn18Text('CESHIHUANJINGZHANG'),
                });
            }
            reject();
        }, 30 * 1000);
        const uid = eventApi.registerSysEventObserver('bkStableSwitchAccount', {
            name: 'bkStableSwitchAccount-main',
            func: async (ev) => {
                const data = ev.eventData;
                const { currentUser, currentNode, authInfo, pass, accountId, account: _account = [], accountInfo: _accountInfo = [] } = data || {};
                if (accountId && accountId === id) {
                    if (window.bridgeApi && window.bridgeApi.master) {
                        window.bridgeApi.master.forbiddenBbWin4CurrPage();
                    }
                    httpImpl.setLogoutStatus(true);
                    if (currentUser) {
                        storeApi.setLastAccount(currentUser);
                        if (currentUser.cookies && currentUser.cookies.length) {
                            await window.electronLib.appManage.clearCookieStore();
                            await window.electronLib.appManage.setCookieStore(currentUser.cookies);
                        }
                    }
                    if (currentNode) {
                        storeApi.setCurrentNode(currentNode);
                    }
                    if (authInfo) {
                        productAuthApi.setStoreAuthInfo(authInfo);
                    }
                    eventApi.unregisterSysEventObserver('bkStableSwitchAccount', uid);
                    clearTimeout(timer);
                    if (pass) {
                        systemApi.closeSubWindow(winId, false, true);
                        if (_account && _account.length) {
                            _account.forEach(accountItem => {
                                accountItem.expired = false;
                            });
                        }
                        Promise.all([accountApi.doUpdateAccountList(_account), accountApi.storeAccountInfoList(_accountInfo)])
                            .then(() => {
                            resolve(true);
                        })
                            .catch(error => {
                            resolve(false);
                            console.error('[login_redux] doSwitchAccountAsync error', error);
                        });
                    }
                    else {
                        if (config('stage') !== 'prod') {
                            Message.info({ content: getIn18Text('CESHIHUANJINGZHANG') });
                        }
                        resolve(false);
                    }
                }
            },
        });
    });
};
const webSwitchAccount = async (id) => {
    const { pass } = await loginApi.doAutoLogin(id);
    return pass;
};
const switchSharedAccount = (id) => {
    return loginApi.switchSharedAccount(id);
};
export const doSwitchAccountAsync = createAsyncThunk('loginReducer/switchAccount', async (id, { rejectWithValue, dispatch }) => {
    var _a;
    try {
        const preAccount = (_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id;
        dispatch(actions.setSwitchingAccount(id));
        const pass = await switchLocalAccount(id);
        if (pass) {
            await handleSwitchAccountSuccessed();
            return true;
        }
        else {
            SiriusModal.error({
                title: getIn18Text('ZHANGHAOYISHIXIAO'),
                content: getIn18Text('ZHANGHAO') + id + getIn18Text('YIJINGSHIXIAO\uFF0C'),
                okText: getIn18Text('ZHONGXINDENGLU'),
                maskClosable: false,
                onOk: () => {
                    if (systemApi.isElectron()) {
                        loginApi.showCreateAccountPage(id);
                    }
                    else {
                        dispatch(actions.setLoginModalData({
                            visible: true,
                            account: id,
                            preAccount,
                        }));
                    }
                },
                onCancel: async () => {
                    if (!systemApi.isElectron() && preAccount) {
                        const res = await loginApi.doAutoLogin(preAccount);
                        if (res.pass) {
                            setLoginBlock(false);
                        }
                        else {
                            Message.error(getIn18Text('ZHANGHAOSHIXIAO'));
                            sendLogout();
                        }
                    }
                },
            });
            await setAccountExpired(id);
        }
        dispatch(actions.setSwitchingAccount(''));
        await dispatch(doListAccountsAsync());
    }
    catch (error) {
        Message.error(getIn18Text('ZHANGHAOQIEHUANCHAO'));
    }
    return rejectWithValue(getIn18Text('ZHANGHAODENGLUZHUANG11'));
});
export const doSwitchSharedAccountAsync = createAsyncThunk('loginReducer/switchSharedAccount', async (id, { dispatch, rejectWithValue }) => {
    const errorTipText = getIn18Text('SWITCH_SHARED_ACCOUNT_ERROR');
    try {
        dispatch(actions.setSwitchingAccount(id));
        const res = await switchSharedAccount(id);
        dispatch(actions.setSwitchingAccount(''));
        if (!res.success) {
            dispatch(doSharedAccountAsync(true));
            console.error(`switchSharedAccount error`, res.errMsg);
            SiriusModal.error({
                content: res.errMsg || errorTipText,
                okText: getIn18Text('ZHIDAOLE'),
                hideCancel: true,
            });
            return;
        }
        return;
    }
    catch (error) {
        Message.error(errorTipText);
    }
    return rejectWithValue(errorTipText);
});
export const doSwitchMobileAccountAsync = createAsyncThunk('loginReducer/switchMobileAccount', async (params, { dispatch }) => {
    const { id, riskManage } = params;
    const data = await accountApi.doGetMobileAccountInfo(id);
    const { enabledMobileLogin, accountId, lastLoginTime, status } = data[0];
    const { account, domain } = systemApi.handleAccountAndDomain(accountId);
    if (String(status) !== '0') {
        SiriusModal.error({
            title: getIn18Text('ZHANGHAOWUFADENG'),
            content: getIn18Text('DANGQIANNINDEZHANG'),
            hideCancel: true,
        });
        return;
    }
    if (!enabledMobileLogin) {
        SiriusModal.error({
            title: getIn18Text('ZHANGHAOWUFADENG'),
            content: getIn18Text('DANGQIANNINDEZHANG11'),
            hideCancel: true,
        });
        return;
    }
    if (!lastLoginTime) {
        SiriusModal.info({
            title: getIn18Text('WANGYILINGXIBAN12'),
            content: getIn18Text('BENCIDENGLUXU'),
            onOk: () => {
                dispatch(actions.setMailBindModalInfo({ visible: true, account: accountId }));
            },
        });
        return;
    }
    if (enabledMobileLogin && lastLoginTime) {
        SiriusModal.error({
            title: getIn18Text('QUERENQIEHUANDAO'),
            content: getIn18Text('QIEHUANZHANGHAOHUI'),
            onOk: () => {
                (async () => {
                    console.log('[login] SwitchMobileAccount doMobileTokenLogin into:');
                    systemApi.switchLoading(true);
                    const loginRes = await loginApi.doMobileBindAccountLogin({
                        account_name: account,
                        domain,
                    });
                    console.log('[login] SwitchMobileAccount doMobileTokenLogin return:', loginRes);
                    const { pass, errmsg, errCode, riskVerify } = loginRes;
                    if (pass) {
                        util.reload();
                        return;
                    }
                    else {
                        if (riskVerify) {
                            riskManage &&
                                riskManage({
                                    val: loginRes,
                                    callback: async (sucRes) => {
                                        await loginApi.doMobileTokenLoginSuc({ res: sucRes.res });
                                        systemApi.switchLoading(false);
                                        util.reload();
                                    },
                                });
                            return;
                        }
                    }
                    systemApi.switchLoading(false);
                    Message.info({ content: errmsg || errCode || getIn18Text('WEIZHICUOWU') });
                })();
            },
        });
    }
});
export const onRegisterValidateCode = createAsyncThunk('loginReducer/onRegisterValidateCode', async ({ mobile, code }, { dispatch }) => {
    const { success, isRegister, message, data } = await registerApi.doValidateCode({ mobile, code });
    if (success) {
        if (isRegister && data) {
            dispatch(actions.setMobileBindAccountListInfo({
                accountList: data,
                visibleList: true,
            }));
        }
        else {
            dispatch(actions.setRegisterInfo({
                visible: true,
            }));
        }
    }
    else {
        message && Message.info(message);
    }
});
export const onLoginValidateCode = createAsyncThunk('loginReducer/onLoginValidateCode', async ({ code }, { dispatch }) => {
    const { success, message, data } = await loginApi.doMobileVerifyCode(code);
    if (success) {
        if (data === null || data === void 0 ? void 0 : data.length) {
            const lastLoginAccount = data.find(item => item.token);
            if (lastLoginAccount) {
                const { pass, errmsg } = await loginApi.doMobileTokenLogin({
                    domain: lastLoginAccount.domain,
                    token: lastLoginAccount.token,
                    account_name: lastLoginAccount.accountName,
                });
                if (pass) {
                    window.location.assign('/');
                }
                else {
                    Message.info(errmsg);
                }
            }
            else {
                dispatch(actions.setMobileBindAccountListInfo({
                    accountList: data,
                    visibleList: true,
                }));
            }
        }
        else {
            actions.setVisibleSwitchModal(true);
        }
    }
    else {
        message && Message.info(message);
    }
});
export default LoginSlice.reducer;
